import { TextField, TextFieldProps } from '@mui/material'
import { Control, Controller, FieldValues } from 'react-hook-form'

type SmartInputProps = {
  control?: Control<FieldValues, object>
  name: string
  type?: string
  label?: string
  variant?: string
  defaultValue?: any
} & TextFieldProps

export default function Input({
  control,
  name,
  type,
  label,
  variant = 'outlined',
  InputProps,
  defaultValue,
  ...rest
}: SmartInputProps) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ''} // ✅ Always controlled
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { error },
      }) => (
        <TextField
          type={type}
          label={label}
          variant={variant}
          InputProps={InputProps}
          onBlur={onBlur}
          onChange={onChange}
          inputRef={ref}
          value={value}
          name={name}
          error={Boolean(error?.message)}
          helperText={error?.message ? error.message : rest.helperText}
          sx={{ flexGrow: '1' }}
          {...rest}
        />
      )}
    />
  )
}
